import { useEffect } from 'react'
import { LeadPhoneDrawer } from '@forwardflow/features/campaign-flow/components/phone/LeadPhoneDrawer'
import { useSpeechFill } from '@forwardflow/features/campaign-flow/hooks/useFlowHelpers'
import { useTestRun } from '@forwardflow/features/campaign-flow/hooks/useTestRun'
import {
   activeType,
   useCampaignFlowStore,
} from '@forwardflow/features/campaign-flow/store/flow.store'
import { viewFor } from '@forwardflow/features/campaign-flow/utils/playbook'

/**
 * "Try it as a lead" from the launch screen: the same phone drawer the
 * playbook uses, over the launch screen, playing the first lead type's words.
 */
export const LaunchPhone = ({
   open,
   onClose,
}: {
   open: boolean
   onClose: () => void
}) => {
   const playbook = useCampaignFlowStore((s) => s.draft.playbook)
   const type = useCampaignFlowStore(activeType)
   const say = useSpeechFill()
   const run = useTestRun(viewFor(playbook, type), say)
   /* Opening starts the first call straight away. */
   useEffect(() => {
      if (open && !run.item) run.start()
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [open])
   return <LeadPhoneDrawer open={open} onClose={onClose} run={run} />
}
